import React from 'react';
import { Grid3X3 } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface CorrelationChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const CorrelationChartIcon: React.FC<CorrelationChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <Grid3X3 size={size} color={color} />
        </IconWrapper>
    );
};
